var render, staticRenderFns
import script from "./HyperLinkDashboard.vue?vue&type=script&lang=js&"
export * from "./HyperLinkDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HyperLinkDashboard.vue?vue&type=style&index=0&id=5b991620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b991620",
  null
  
)

export default component.exports